import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import { get } from "lodash";

import { ReactComponent as Locomotive } from "./assets/locomotive.svg";
import { ReactComponent as Tanker }  from "./assets/tanker.svg";
import { ReactComponent as OpenHopper }  from "./assets/open_hooper.svg";
import { ReactComponent as Flatcar }  from "./assets/flat_car.svg";
import { ReactComponent as Container }  from "./assets/long_container.svg"
import { ReactComponent as Trailer } from "./assets/trailer_icon_black.svg"
import { ReactComponent as Reefer } from "./assets/reefer.svg"
import { ReactComponent as ClosedHopper }  from "./assets/closed_hooper.svg";
import { ReactComponent as BoxCar }  from "./assets/box_car.svg";
import { ReactComponent as RefrigeratedBoxCar }  from "./assets/refrigerated_boxcar.svg";
import { ReactComponent as WellCar }  from "./assets/well_car.svg";
import { ReactComponent as CenterBeam }  from "./assets/center_beam.svg";
import { ReactComponent as AutoRack }  from "./assets/auto_rack.svg";
import { ReactComponent as Gondola }  from "./assets/gondola.svg";
import { ReactComponent as Maintenance }  from "./assets/maintenance_car.svg";
import { ReactComponent as Passenger }  from "./assets/passenger_car.svg";
import { ReactComponent as CoilCar }  from "./assets/coil_car.svg";

const styles = {
  railcarIcon: {

    width: "100%",
    height: "100%",

    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    fontSize: "14px",
    boxSizing: "border-box",

  },

};



const RailcarIcon = (props) => {
  const { classes, type } = props;

//   React.useEffect(() => {
//     console.log(data.code)
//   }, [data])

  const handleRender = type => {
    if (type === 171) {
      return <Locomotive />
    } else if (type === 172) {
      return <Maintenance />
    } else if (type === 173) {
      return <AutoRack />
    } else if (type === 174) {
      return <BoxCar />
    } else if (type === 175) {
      return <RefrigeratedBoxCar />
    } else if (type === 176) {
      return <CenterBeam />
    } else if (type === 177) {
      return <ClosedHopper  />
    } else if (type === 178) {
      return <OpenHopper  />
    } else if (type === 179) {
      return <Gondola />
    } else if (type === 180) {
      return <Tanker />
    } else if (type === 181) {
      return <WellCar />
    } else if (type === 182) {
      return <Flatcar />
    } else if (type === 183) {
      return <Passenger />
    } else if (type === 184) {
      return <div style={{fontWeight: 500}}>OTHER</div>
    } else if (type === 185) {
      return <CoilCar />
    }
    else if (type === "Container") {
      return <Container color={"#000"} />
    } else if (type === "Reefer") {
      return <Reefer />
    } else if (type === "Trailer") {
      return <Trailer />
    }
  }

  return (
    <div className={classes.railcarIcon}>
      {handleRender(type)}
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(RailcarIcon))

);